/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Enable_HintInputs */



/**
* | output |
* | --- |
* | "While on, customers see the banner across the app. Press again to hide it." |
*
* @param {Partner_Status_Enable_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_enable_hint = /** @type {((inputs?: Partner_Status_Enable_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Enable_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Solange aktiv, sehen Kunden das Banner app-weit. Erneut drücken, um es auszublenden.")
	return /** @type {LocalizedString} */ ("While on, customers see the banner across the app. Press again to hide it.")
});